import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import management from './management';
import accounting from './accounting';
import dashboard from './dashboard';
import operations from './operations';
import products from './products';
import sales from './sales';
import reports from './reports';
import webManagement from './web-management';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/auth/Login.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../pages/profile/profile.shell.vue'),
  },
  ...dashboard,
  ...products,
  ...operations,
  ...accounting,
  ...management,
  ...sales,
  ...reports,
  ...webManagement,
  {
    path: '*',
    name: 'error404',
    component: () => import('../pages/error/Error404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login' && !store.state.auth?.accessToken) {
    next('/login');
  } else {
    next();
  }
});

export default router;
